// React Query keys dla manager view (tabela kampanii klienta → drill-down ad-set/ad).
//
// VP-205: `customRange` MUSI być częścią KAŻDEGO klucza. Przy `datePreset='custom'`
// preset zostaje stały między dniami, więc pominięcie `customRange` w kluczu sprawia,
// że React Query oddaje zacache'owane dane poprzednio wybranego dnia (zamiast refetchu)
// — nagłówek kampanii pokazuje nowy dzień, a rozbicie ad-setów stary. Te helpery
// gwarantują spójny kształt klucza we wszystkich trzech poziomach drill-downu.

export type MetaDateRange = { since: string; until: string };

export const managerCampaignsKey = (
  adAccountId: string,
  datePreset: string,
  customRange?: MetaDateRange
) => ["/api/manager/client-campaigns", adAccountId, datePreset, customRange] as const;

export const managerAdSetsKey = (
  campaignId: string,
  adAccountId: string,
  datePreset: string,
  customRange?: MetaDateRange
) => ["/api/manager/client-adsets", campaignId, adAccountId, datePreset, customRange] as const;

export const managerAdsKey = (
  adSetId: string,
  adAccountId: string,
  datePreset: string,
  customRange?: MetaDateRange
) => ["/api/manager/client-ads", adSetId, adAccountId, datePreset, customRange] as const;
